import ROUTES from 'app/routes/paths';
import {
  UiWithDefinitionPreviewParams,
  UiWithDraftProcessId,
  UiWithReleaseOrDraftProcessId,
} from 'app/routes/uiPathParams';
import UiUrlParams from 'constants/uiUrlParams';

type PathCreator<T> = (params: UiWithDefinitionPreviewParams & T) => string;

interface UrlCreator<T> {
  _: PathCreator<T>;
}

export enum DefinitionEntity {
  fields = 'fields',
  adjacentDocuments = 'adjacentDocuments',
  versions = 'versions',
  security = 'security',
}

export enum DefinitionVersionEntity {
  fields = 'fields',
  forms = 'forms',
  adjacentDocuments = 'adjacentDocuments',
  security = 'security',
  emailTemplates = 'emailTemplates',
  indexingSources = 'indexingSources',
}

const getRouteByVersion = <T = {}>({
  ids,
  entity,
  urlCreator,
}: {
  ids: UiWithDefinitionPreviewParams & T;
  entity?: DefinitionEntity | DefinitionVersionEntity;
  urlCreator?: UrlCreator<T>;
}) => {
  if (urlCreator) {
    return urlCreator._(ids);
  }
  return ids[UiUrlParams.processVersionId]
    ? ROUTES.process.definition.details.version[
        entity as DefinitionVersionEntity
      ](ids)
    : ROUTES.process.definition.details[entity as DefinitionEntity](
        ids as UiWithDefinitionPreviewParams &
          UiWithReleaseOrDraftProcessId &
          UiWithDraftProcessId
      );
};

export { getRouteByVersion };
